import { render, staticRenderFns } from "./customerEdit.vue?vue&type=template&id=46cb663b&scoped=true"
import script from "./customerEdit.vue?vue&type=script&lang=js"
export * from "./customerEdit.vue?vue&type=script&lang=js"
import style0 from "./customerEdit.vue?vue&type=style&index=0&id=46cb663b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cb663b",
  null
  
)

export default component.exports